import React, { FC } from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';

// models
import { SearchableSelectType } from '../../components/inputs/searchableSelect';
// components
import AampeTooltip from '../../components/shared/AampeTooltip/AampeTooltip';

// theme
import aampeTheme from '../../constants/aampeTheme';

import {
    ALL_USERS_AUDIENCE_ID,
    AudienceMainModel,
} from '../../models/audience.model';

import FormulaAudienceHoverCard from './FormulaAudienceHoverCard';

interface AudienceOnHoverFiltersProps
    extends OptionProps<SearchableSelectType, boolean> {
    audience?: AudienceMainModel;
    showHoverCard: boolean;
}

const AudienceOnHoverFilters: FC<
    React.PropsWithChildren<AudienceOnHoverFiltersProps>
> = ({ audience, showHoverCard, ...props }) => {
    return (
        <components.Option {...props}>
            <AampeTooltip
                title={
                    props.data.value !== ALL_USERS_AUDIENCE_ID &&
                    showHoverCard &&
                    audience && <FormulaAudienceHoverCard audience={audience} />
                }
                customZIndex={4000}
                backgroundColor={aampeTheme.colors.white}
            >
                <div>{props.label}</div>
            </AampeTooltip>
        </components.Option>
    );
};

export default AudienceOnHoverFilters;
